// extracted by mini-css-extract-plugin
module.exports = {"link-creating-sales-type":"_32821fEMMhBXkls06fSsD1"};